import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router';
import { FOOTER_MOBILEMENU } from './Menu';
import { FooterMobileStyled, MobileFooterMenu } from '../styles/layOutStyles';
import Alert from '../helpers/Alert';

import { connect } from 'react-redux';

import smoothscroll from 'smoothscroll-polyfill';

const validateLink = ['/home', '/onair', '/search', '/schedule', '/my'];

const FooterMobile = ({ userInfo }) => {
  const history = useHistory();
  const [path, setPath] = useState('/');

  const bottomMenuOnclick = (path, nowMenu) => {
    if (nowMenu) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      smoothscroll.polyfill();

      return;
    }

    if (path === '/my') {
      if (!userInfo) {
        goLogin();
        return;
      }
      path = '/my?tab=0';
    }
    if (path === '/schedule') path = '/schedule?tab=0';
    if (path === '/search') path = '/search?tab=0';

    history.push(process.env.PUBLIC_URL + `${path}`);
  };

  useEffect(() => {
    let _path = window.location.pathname;
    let url = '/';

    if (validateLink.includes(_path)) url = _path;

    setPath(url);
  }, []);

  const goLogin = () => {
    Alert('', '로그인이 필요한 서비스입니다. <br /> 로그인 하시겠습니까?', '아니요', '로그인 하러가기', res => {
      if (res) history.push(`/login`);
    });
  };

  return (
    <FooterMobileStyled container direction={'row'} justifyContent={'space-between'} alignItems='center'>
      {FOOTER_MOBILEMENU.map((item, idx) => {
        let now = false;

        if (path.includes(item.pathname)) {
          now = true;
        }

        return (
          <MobileFooterMenu item key={`${item.label}_${idx}`} active={now} onClick={() => bottomMenuOnclick(item.pathname, now)}>
            <Grid container direction={'column'}>
              <button>
                <i className={`icon ${item.icon}dark${now ? 'active' : ''}`} />
              </button>
              <div>{item.label}</div>
            </Grid>
          </MobileFooterMenu>
        );
      })}
    </FooterMobileStyled>
  );
};

const mapStateToProps = state => {
  return {
    userInfo: state.userData.user,
  };
};

export default React.memo(connect(mapStateToProps)(FooterMobile));
